import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {FileUploader} from "ng2-file-upload";
import {environment} from "../../../../../environments/environment";
import {RequestService} from "../../../../services/request/request.service";
import {AuthService} from "../../../../services/auth/auth.service";
import {AlertBannerService, AlertType} from "../../../../lib/alert-banner";
import { ConstantsService } from 'src/app/services/constants/constants.service';
import { PermissionsService } from '../../../../services/permissions/permissions.service';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-reference-bulk-upload',
  templateUrl: './reference-bulk-upload.component.pug',
  styleUrls: ['./reference-bulk-upload.component.scss'],
  standalone: false
})
export class ReferenceBulkUploadComponent implements OnInit {
  @ViewChild('fileInput', {static: false}) fileInput: any;
  @Input() set selectedCheckType(value: any) {
    this.checkTypeSubject.next(value);
  }
  @Input() backgroundCheckName: any;
  checkType: string | null = '';
  @Output() tableData = new EventEmitter();
  @Output() errorMessages = new EventEmitter();
  @Output() clear = new EventEmitter();
  public recipientDetails: any;
  draftResponse = {};
  recipients: {}[] = [];
  uploader!: FileUploader;
  draftReferenceUid: string | null = '';
  draftBackgroundCheckUid: string | null = '';
  fileIsOverDropZone = false;
  environmentUrl = environment.API;
  messages: Array<any> = [];
  maxFileSize = 0.5 * 1024 * 1024; // 0.5*1024*1024 = 0.5MB
  fileSizeError = false;
  file: any;
  currentFile: any;
  numberOfPeople = 0;
  importedData!: any;
  dataForTable = {};
  bulkErrorMap = new Map([
    ["more_than_permitted_rows", new Map([['exceeded_limit', $localize`The number of total recipients for reference surveys cannot exceed 100. Please delete rows from your .csv file and try again.`]])],
    ["file", new Map([["invalid_type", $localize`Incorrect file type, please upload .csv only.`],
      ["wrong_headers", $localize`Oops, some of the content in your CSV does not match our CSV template. Please check your file and try again.`]])]
  ]);
  backgroundCheckBulkErrorMap = new Map([
    ["more_than_permitted_rows", new Map([['exceeded_limit', $localize`The number of total recipients for background checks cannot exceed 100. Please delete rows from your .csv file and try again.`]])],
    ["file", new Map([["invalid_type", $localize`Incorrect file type, please upload .csv only.`],
      ["wrong_headers", $localize`Oops, some of the content in your CSV does not match our CSV template. Please check your file and try again.`]])]
  ]);
  referenceCheck = ConstantsService.REFERENCE_CHECK;
  backgroundCheck = ConstantsService.BACKGROUND_CHECK;
  private checkTypeSubject = new BehaviorSubject<any>(null);

  constructor(private requestService: RequestService,
              private authservice: AuthService,
              private alertList: AlertBannerService,
              private permissions: PermissionsService
  ) {


    this.uploader = new FileUploader({
      url: this.environmentUrl + '/check/references/create',
      method: 'POST',
      disableMultipart: false,

      formatDataFunction: async (item) => {
        return new Promise((resolve, reject) => {
          resolve({
            name: item._file.name,
            length: item._file.size,
            contentType: item._file.type,
            date: new Date()
          });
        });
      },
    });

   this.handleCheckTypeSelection();

  }

  ngOnInit(): void {
    this.uploader.onAfterAddingFile = (file: any) => {
      this.fileInput.nativeElement.value = '';
      this.validateFile(file);
    };
  }

  handleCheckTypeSelection() {
    this.checkTypeSubject.subscribe((selectedCheckType) => {
      if (selectedCheckType) {
        this.checkType = selectedCheckType;
        //reference
        if (selectedCheckType === this.referenceCheck) {
          this.uploader.response.subscribe(res => {
            this.numberOfPeople = res['total_references']
            localStorage.setItem('draft_reference_uid', res['draft_reference_uid']);
            this.draftReferenceUid = res['draft_reference_uid'];
            this.retrieveRecipientTableData()
          });
        } else if (selectedCheckType === this.backgroundCheck) {
          //background-check
          this.uploader.response.subscribe(res => {
            this.numberOfPeople = res['total_references']
            localStorage.setItem('draft_background_check_uid', res['draft_reference_uid']);
            this.draftBackgroundCheckUid = res['draft_reference_uid'];
            this.retrieveBackgroundCheckRecipientTableData()
          });
        }
      }
    });
  }

  createOrAppend(file) {
    let payload = new FormData();
    if (this.file !== null) {
      payload.append('file', file);
    }
    this.handleDataCreationOrAppend(payload);

  }

  handleDataCreationOrAppend(payload) {
    //Reference
    if (this.checkType === this.referenceCheck) {
      if (localStorage.getItem('draft_reference_uid')) {
        this.draftReferenceUid = localStorage.getItem('draft_reference_uid');
        this.addReferenceToDraft(payload);
      } else {
        this.addRecipientDetails(payload);
      }
    } else if (this.checkType === this.backgroundCheck) {
      //Background-Check
      if (localStorage.getItem('draft_background_check_uid')) {
        this.draftBackgroundCheckUid = localStorage.getItem('draft_background_check_uid');
        this.addBackgroundCheckToDraft(payload);
      } else {
        this.addBackgroundCheckRecipientDetails(payload);
      }
    }
  }

  handleDataCreationOrAppendLegacy(payload){
    if (localStorage.getItem('draft_reference_uid')) {
      this.draftReferenceUid = localStorage.getItem('draft_reference_uid');
      this.addReferenceToDraft(payload);
    } else {
      this.addRecipientDetails(payload);
    }
  }

  addRecipientDetails(payload) {
      this.requestService.createBackgroundCheck(payload, undefined, false).subscribe((data: any) => {
        this.draftReferenceUid = data['draft_check_uid'];
        if (typeof this.draftReferenceUid === "string") {
          localStorage.setItem('draft_reference_uid', this.draftReferenceUid);
        }
        this.retrieveRecipientTableData();
      },
      (error: any) => {
        console.log(error);
        if (error.error['data'] !== null) {
          for (const [key, value] of Object.entries(error.error['data']['errors'])) {
            let key_map = this.bulkErrorMap.has(key) ? this.bulkErrorMap.get(key) : new Map();
            let message: string = key_map?.has(value) ? key_map?.get(value) : $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`
            this.messages.push({
              'type': 'danger',
              'message': message
            });
          }
        } else {
          this.messages.push({
            'type': 'danger',
            'message': $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`
          });
        }
        this.errorMessages.emit(this.messages);
      })

  }

  deprecatedAddRecipientDetails(payload){
    this.requestService.deprecatedCreateReference(payload).subscribe((data: any) => {
        this.draftReferenceUid = data['draft_reference_uid'];
        if (typeof this.draftReferenceUid === "string") {
          localStorage.setItem('draft_reference_uid', this.draftReferenceUid);
        }
        this.retrieveRecipientTableData();
      },
      (error: any) => {
        console.log(error);
        if (error.error['data'] !== null) {
          for (const [key, value] of Object.entries(error.error['data']['errors'])) {
            let key_map = this.bulkErrorMap.has(key) ? this.bulkErrorMap.get(key) : new Map();
            let message: string = key_map?.has(value) ? key_map?.get(value) : $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`
            this.messages.push({
              'type': 'danger',
              'message': message
            });
          }
        } else {
          this.messages.push({
            'type': 'danger',
            'message': $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`
          });
        }
        this.errorMessages.emit(this.messages);
      })
  }

  addBackgroundCheckRecipientDetails(payload){
    this.requestService.createBackgroundCheck(payload, this.backgroundCheckName).subscribe((data: any) => {
      this.draftBackgroundCheckUid = data['draft_check_uid'];
      if (typeof this.draftBackgroundCheckUid === "string") {
        localStorage.setItem('draft_background_check_uid', this.draftBackgroundCheckUid);
      }
      this.retrieveBackgroundCheckRecipientTableData();
    },
    (error: any) => {
      console.log(error);
      if (error.error['data'] !== null) {
        for (const [key, value] of Object.entries(error.error['data']['errors'])) {
          let key_map = this.backgroundCheckBulkErrorMap.has(key) ? this.backgroundCheckBulkErrorMap.get(key) : new Map();
          let message: string = key_map?.has(value) ? key_map?.get(value) : $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`
          this.messages.push({
            'type': 'danger',
            'message': message
          });
        }
      } else {
        this.messages.push({
          'type': 'danger',
          'message': $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`
        });
      }
      this.errorMessages.emit(this.messages);
    })
  }

  addReferenceToDraft(payload) {
      this.requestService.appendBackgroundCheck(payload, this.draftReferenceUid, undefined, false).subscribe((data: any) => {
        this.numberOfPeople = data['rows_appended'];
        this.dataForTable = {
          "buttonStatus": false,
          "numberOfPeople": this.numberOfPeople,
          "total": data['total_external_checks']
        };
        this.tableData.emit(this.dataForTable);
      },
      (error: any) => {
        console.log("error", error)
        for (const [key, value] of Object.entries(error.error['data']['errors'])) {
          let key_map = this.bulkErrorMap.has(key) ? this.bulkErrorMap.get(key) : new Map();
          let message: string = key_map?.has(value) ? key_map?.get(value) : $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`
          this.messages.push({
            'type': 'danger',
            'message': message
          });
        }
        this.errorMessages.emit(this.messages);
      })
  }

  addBackgroundCheckToDraft(payload){
    this.requestService.appendBackgroundCheck(payload, this.draftBackgroundCheckUid, this.backgroundCheckName).subscribe((data: any) => {
      this.numberOfPeople = data['rows_appended'];
      this.dataForTable = {
        "buttonStatus": false,
        "numberOfPeople": this.numberOfPeople,
        "total": data['total_external_checks']
      };
      this.tableData.emit(this.dataForTable);
    },
    (error: any) => {
      console.log("error", error)
      for (const [key, value] of Object.entries(error.error['data']['errors'])) {
        let key_map = this.backgroundCheckBulkErrorMap.has(key) ? this.backgroundCheckBulkErrorMap.get(key) : new Map();
        let message: string = key_map?.has(value) ? key_map?.get(value) : $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`
        this.messages.push({
          'type': 'danger',
          'message': message
        });
      }
      this.errorMessages.emit(this.messages);
    })
  }

  retrieveRecipientTableData() {
      this.requestService.retrieveDraftBackgroundCheck(this.draftReferenceUid, '', 0, 0, '', '', '', undefined, false).subscribe((data: any) => {
        this.importedData = data['external_checks'];
        this.numberOfPeople = data['total_external_checks'];
        this.dataForTable = {
          "buttonStatus": false,
          "numberOfPeople": this.numberOfPeople,
          "total": data['total_external_checks']
        };
        this.tableData.emit(this.dataForTable);
      },
      (err: any) => {
        if (err.status === 404) {
          localStorage.removeItem('draft_reference_uid')
        } else {
          console.log(err);
          this.alertList.append([{
            type: AlertType.DANGER,
            message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
            keepOnRouteChange: true
          }]);
        }
      })
  }

  retrieveBackgroundCheckRecipientTableData() {
    this.requestService.retrieveDraftBackgroundCheck(this.draftBackgroundCheckUid, '', 0, 0, '', '', '', this.backgroundCheckName).subscribe((data: any) => {
      this.importedData = data['external_checks'];
      this.numberOfPeople = data['total_external_checks'];
      this.dataForTable = {
        "buttonStatus": false,
        "numberOfPeople": this.numberOfPeople,
        "total": data['total_external_checks']
      };
      this.tableData.emit(this.dataForTable);
      },
      (err: any) => {
        if (err.status === 404) {
          localStorage.removeItem('draft_background_check_uid')
        } else {
          console.log(err);
          this.alertList.append([{
            type: AlertType.DANGER,
            message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
            keepOnRouteChange: true
          }]);
        }
      })
  }

  // Validate selected image file before adding to queue and preview
  validateFile(file: any) {
    // Reset errors
    this.fileSizeError = false;
    if (file.some.size > this.maxFileSize) {
      // File size to large
      this.fileSizeError = true;
    }
    this.currentFile = file;

    // Only add file to queue if no validation errors
    if (!this.fileSizeError) {
      this.uploader.queue = [file];
    }
  }

  afterFileDropped(file) {
    this.createOrAppend(file[0])
  }

  afterFileSelected(event) {
    this.createOrAppend(this.uploader.queue[0].file.rawFile)
  }

  fileOverBase(event) {
    this.fileIsOverDropZone = event;
  }

  clearFile() {
    this.currentFile = null;
    this.importedData = {};
    this.uploader.queue.pop();
    this.dataForTable = {
      "buttonStatus": true,
      "numberOfPeople": 0
    }
    this.messages = [];
    this.errorMessages.emit(this.messages);
    this.tableData.emit(this.dataForTable)
  }

  import() {
    this.uploader.uploadAll();
  }

}
